import { _ } from "../../polyglot/polyglot.js";
import AbstractFormStep from "../AbstractFormStep.js";
import Timespan from "../../../models/period/Timespan.js";

/**
 * Wizard step asking the user to select a date range, then the callback receives
 * the selected dates as a Timespan in dateRange.
 *
 * @param {function} spec.getDateRangeFromContext - A function receiving a context
 *   and returning a Timespan
 * @param {Date} spec.startDate - An optional parameter to define the earlier
 *   selectable date in the date pickers. Defaults to Date(0) in the widget
 * @param {Date} spec.endDate - An optional parameter to define the last selectable
 *   date in the date pickers. Defaults to Date(2984,11,31) in the widget
 */
export default class DateRangePickerStep extends AbstractFormStep {
	constructor({ getDateRangeFromContext, startDate, endDate }) {
		super(...arguments);

		this._getDateRangeFromContext = getDateRangeFromContext;
		this._startDate = startDate;
		this._endDate = endDate;
	}

	_populateForm(form) {
		const preselectRange = this._getDateRangeFromContext(this._context);

		this._startPicker = form.datePickerField({
			label: _("Start"),
			date: preselectRange.getStart(),
			startDate: this._startDate,
			endDate: this._endDate,
		});

		this._endPicker = form.datePickerField({
			label: _("End"),
			date: preselectRange.getEnd(),
			startDate: this._startDate,
			endDate: this._endDate,
		});
	}

	_doSubmit({ onDone }) {
		this._submitCallback({
			step: this,
			onDone,
			dateRange: new Timespan({
				start: this._startPicker.getSelectedDate(),
				end: this._endPicker.getSelectedDate(),
			}),
		});
	}
}
